// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color-bg: #ffffff;
  --color-bg-secondary: #f0f2f5;
  --color-text: rgba(0, 0, 0, 0.85);
  --color-text-muted: rgba(0, 0, 0, 0.45);
  --color-border: #d9d9d9;
  --color-accent: #f0f2f5;
  --color-primary: #1890ff;
  --color-theme: #001529;
  --color-dark-blue: #0a3761;
  --color-green: #29600d;
  --color-orange: #9d6d0b;
  --color-red: #7e1215;
  --color-purple: #aa88da;

  /* Dark Theme Variables */
  --dark-bg: #03070e;
  --dark-bg-secondary: #1f1f1f;
  --dark-bg-header: #262626;
  --dark-border: #303030;
  --dark-text: rgba(255, 255, 255, 0.85);
  --dark-text-muted: rgba(255, 255, 255, 0.45);
  --dark-success: #52c41a;
  --dark-warning: #faad14;
  --dark-danger: #e32227;
  --dark-purple: #883eef;
  --dark-gray: #757575;
  --dark-gray-secondary: #8a8a8a;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,iCAAiC;EACjC,uCAAuC;EACvC,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,sBAAsB;EACtB,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,uBAAuB;;EAEvB,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;EACtB,sCAAsC;EACtC,4CAA4C;EAC5C,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;EACtB,oBAAoB;EACpB,8BAA8B;AAChC","sourcesContent":[":root {\n  --color-bg: #ffffff;\n  --color-bg-secondary: #f0f2f5;\n  --color-text: rgba(0, 0, 0, 0.85);\n  --color-text-muted: rgba(0, 0, 0, 0.45);\n  --color-border: #d9d9d9;\n  --color-accent: #f0f2f5;\n  --color-primary: #1890ff;\n  --color-theme: #001529;\n  --color-dark-blue: #0a3761;\n  --color-green: #29600d;\n  --color-orange: #9d6d0b;\n  --color-red: #7e1215;\n  --color-purple: #aa88da;\n\n  /* Dark Theme Variables */\n  --dark-bg: #03070e;\n  --dark-bg-secondary: #1f1f1f;\n  --dark-bg-header: #262626;\n  --dark-border: #303030;\n  --dark-text: rgba(255, 255, 255, 0.85);\n  --dark-text-muted: rgba(255, 255, 255, 0.45);\n  --dark-success: #52c41a;\n  --dark-warning: #faad14;\n  --dark-danger: #e32227;\n  --dark-purple: #883eef;\n  --dark-gray: #757575;\n  --dark-gray-secondary: #8a8a8a;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
